/* ==========================================================================
   Dyese Analyse v2 — dyese-widget.js  (bootstrap interactif)
   --------------------------------------------------------------------------
   Gère : héros + recherche commune (autocomplétion réutilisable), appel de la
   fonction serverless d'analyse, CMP cookies (le tracking ne part qu'APRÈS
   consentement), events GA4, génération PDF côté navigateur (jsPDF) et envoi
   du lead vers le Worker (POST — AUCUNE donnée perso en URL).

   Exposé en global window.DyeseWidget. Dépend de window.DyeseRender.
   ======================================================================== */
(function (root) {
  'use strict';
  var R = root.DyeseRender;

  /* ---------------------- configuration par défaut ---------------------- */
  var DEFAULTS = {
    // ▼▼▼ À BRANCHER (voir config.example.js / schema de la section Shopify) ▼▼▼
    workerBase: '/tools/analyse-eau',      // route Shopify App Proxy → Cloudflare Worker
    gaId: '',                               // ex. 'G-XXXXXXXXXX' (vide = pas de GA4)
    espEndpoint: '',                        // laissé au Worker (/api/lead) par défaut
    logoUrl: '',                            // logo BLANC (fonds sombres : héros, reco)
    logoUrlDark: '',                        // logo NOIR/navy (fonds clairs : bloc accueil)
    brandName: 'Dyese',
    mode: 'page',                           // 'page' = analyseur complet · 'accueil' = bloc HP 2 étapes
    analysePath: '/pages/analyse-de-mon-eau', // page de destination du bloc accueil
    autoFromUrl: true,                      // lit ?insee=&udi=&commune= et lance l'analyse
    products: {                             // ► vos produits Shopify (URL + variant)
      robinet:        { titre: 'Filtre robinet 0,2 µm', desc: 'Microfiltration sur le robinet de cuisine : micro-organismes et particules ≥ 0,2 µm retenus.', url: '#TODO-url-robinet', variant: '' },
      robinet_charbon:{ titre: 'Filtre robinet charbon actif', desc: 'Réduit le chlore, les sous-produits et les mauvais goûts. Confort de dégustation.', url: '#TODO-url-robinet-charbon', variant: '' },
      douche:         { titre: 'Filtre douche', desc: 'Protège à la douche : légionelle et particules retenues par le pore 0,2 µm.', url: '#TODO-url-douche', variant: '' },
      sous_evier:     { titre: 'Système sous-évier / en ligne', desc: 'Média spécifiques pour cibler les composés dissous (voir la fiche pour les performances validées).', url: '#TODO-url-sous-evier', variant: '' },
      bofi:           { titre: 'Gourde filtrante BOFI', desc: 'Une eau bonne à emporter, sans plastique jetable. Idéale quand l’eau est déjà de qualité.', url: '#TODO-url-bofi', variant: '' },
    },
    // ▲▲▲ fin de la zone à brancher ▲▲▲
    demo: false,        // true = utilise demoData pour 38185 (aucun réseau requis)
    demoData: null,     // objet analysis embarqué (snapshot Grenoble)
    demoCommunes: [{ code: '38185', nom: 'Grenoble', dep: 'Isère' }],
    hasConsent: null,   // fonction () => bool si vous branchez VOTRE CMP
  };

  /* ------------------------------- état --------------------------------- */
  var state = { consent: false, gaLoaded: false, current: null, cfg: null, cmpHandled: false };

  /* ----------------------------- helpers -------------------------------- */
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------------------- consentement / GA4 ---------------------------- */
  function hasConsent() { return state.cfg.hasConsent ? !!state.cfg.hasConsent() : state.consent; }
  function loadGA() {
    if (state.gaLoaded || !state.cfg.gaId) return;
    state.gaLoaded = true;
    var s = document.createElement('script');
    s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(state.cfg.gaId);
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', state.cfg.gaId, { anonymize_ip: true });
  }
  function track(event, params) {
    // Le tracking ne part QU'APRÈS consentement (RGPD / CMP avant tracking).
    if (!hasConsent()) return;
    loadGA();
    if (window.gtag) window.gtag('event', event, params || {});
  }

  /* ------------------------------- CMP ---------------------------------- */
  function mountCMP() {
    if (state.cfg.hasConsent) return;            // le client gère son propre CMP
    if (state.cmpHandled) return;                // choix déjà exprimé (ne pas re-demander)
    if (document.querySelector('.dy-cmp')) return; // bannière déjà présente
    var bar = el('' +
      '<div class="dy-cmp" role="dialog" aria-label="Consentement cookies">' +
        '<p>Nous utilisons des cookies de mesure d’audience pour améliorer cet outil. ' +
          'Ils ne sont déposés qu’avec votre accord.</p>' +
        '<div class="dy-cmp__row">' +
          '<button class="dy-btn" data-dy="accept">Accepter</button>' +
          '<button class="dy-btn dy-btn--ghost" data-dy="refuse" style="color:#fff;border-color:rgba(255,255,255,.5)">Refuser</button>' +
        '</div>' +
      '</div>');
    function done(consent) { state.consent = consent; state.cmpHandled = true; if (consent) loadGA(); bar.remove(); }
    bar.querySelector('[data-dy="accept"]').addEventListener('click', function () { done(true); });
    bar.querySelector('[data-dy="refuse"]').addEventListener('click', function () { done(false); });
    document.body.appendChild(bar);
  }

  /* ------------------------- appels serverless -------------------------- */

  function api(path) { return state.cfg.workerBase.replace(/\/$/, '') + path; }

  /* ------------------- continuité HP -> page d'analyse ------------------ */
  var SELECTION_KEY = 'dyese-analyse-selection-v1';

  function validInsee(code) {
    return /^(\d{5}|2[AB]\d{3})$/i.test(String(code || '').trim());
  }

  function saveSelection(code, nom, udi) {
    try {
      window.sessionStorage.setItem(SELECTION_KEY, JSON.stringify({
        insee: String(code || '').trim().toUpperCase(),
        commune: String(nom || '').trim(),
        udi: String(udi || '').trim(),
        ts: Date.now()
      }));
    } catch (e) {}
  }

  function readStoredSelection() {
    try {
      var raw = window.sessionStorage.getItem(SELECTION_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      /* Le secours session n'est valable que 10 minutes : il sert uniquement
         à fiabiliser le passage HP -> page d'analyse. */
      if (!s || !validInsee(s.insee) || !s.ts || (Date.now() - s.ts) > 10 * 60 * 1000) {
        window.sessionStorage.removeItem(SELECTION_KEY);
        return null;
      }
      return {
        insee: String(s.insee).toUpperCase(),
        commune: s.commune || s.insee,
        udi: s.udi || '',
        source: 'session'
      };
    } catch (e) {
      return null;
    }
  }

  function clearStoredSelection() {
    try { window.sessionStorage.removeItem(SELECTION_KEY); } catch (e) {}
  }

  function readUrlSelection() {
    if (typeof URLSearchParams !== 'function') return null;
    var q = new URLSearchParams(window.location.search || '');
    var insee = (q.get('insee') || '').trim();
    if (!validInsee(insee)) return null;
    return {
      insee: insee.toUpperCase(),
      commune: (q.get('commune') || insee).trim(),
      udi: (q.get('udi') || '').trim(),
      source: 'url'
    };
  }

  function analyseUrl(code, nom, udi) {
    var base = String(state.cfg.analysePath || DEFAULTS.analysePath || '/pages/analyse-de-mon-eau').trim();

    /* Une valeur shopify:// n'est pas une URL navigable côté navigateur.
       On retombe sur le chemin public prévu. */
    if (!base || /^shopify:\/\//i.test(base)) base = DEFAULTS.analysePath;

    try {
      var u = new URL(base, window.location.origin);
      u.searchParams.set('insee', String(code || '').trim().toUpperCase());
      u.searchParams.set('commune', String(nom || '').trim());
      if (udi) u.searchParams.set('udi', String(udi).trim());
      else u.searchParams.delete('udi');
      return u.toString();
    } catch (e) {
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      return base + sep +
        'insee=' + encodeURIComponent(String(code || '').trim().toUpperCase()) +
        '&commune=' + encodeURIComponent(String(nom || '').trim()) +
        (udi ? '&udi=' + encodeURIComponent(String(udi).trim()) : '');
    }
  }

  function searchCommunes(q) {
    q = (q || '').trim();
    if (q.length < 2) return Promise.resolve([]);
    if (state.cfg.demo) {
      var low = q.toLowerCase();
      return Promise.resolve(state.cfg.demoCommunes.filter(function (c) { return c.nom.toLowerCase().indexOf(low) === 0 || c.code.indexOf(q) === 0; }));
    }
    return fetch(api('/api/communes?q=' + encodeURIComponent(q)))
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (d) { return (d && d.communes) || d || []; })
      .catch(function () { return []; });
  }

  function fetchReseaux(code) {
    if (state.cfg.demo) {
      return Promise.resolve({ reseaux: (state.cfg.demoReseaux || []) });
    }
    return fetch(api('/api/reseaux?insee=' + encodeURIComponent(code)))
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .catch(function () { return { reseaux: [] }; });
  }

  function fetchAnalyse(code, udi) {
    // Analyse pré-embarquée (pages SEO App Proxy : pas de re-fetch) ou démo.
    if (state.cfg.preload && state.cfg.preload[code]) return Promise.resolve(state.cfg.preload[code]);
    if (state.cfg.demo) {
      if (code === '38185' && state.cfg.demoData) return Promise.resolve(state.cfg.demoData);
      return Promise.reject(new Error('demo-only'));
    }
    return fetch(api('/api/analyse?insee=' + encodeURIComponent(code) + (udi ? '&udi=' + encodeURIComponent(udi) : '')))
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }

  /* --------------------------- construction UI -------------------------- */
  function heroHTML(cfg) {
    if (cfg.mode === 'accueil') return accueilHTML(cfg);
    return '' +
      '<section class="dy-hero">' +
        (cfg.logoUrl ? '<img class="dy-hero__logo" src="' + cfg.logoUrl + '" alt="' + cfg.brandName + '">' : '') +
        '<p class="dy-eyebrow dy-eyebrow--light">Qualité de l\u2019eau potable · données officielles</p>' +
        '<h1>Quelle est vraiment la qualité de votre eau du robinet ?</h1>' +
        '<p class="dy-hero__sub">Entrez votre commune pour lire clairement les derniers contrôles disponibles : bactériologie, chlore et sous-produits, particules, pesticides, PFAS, nitrates, métaux et minéraux.</p>' +
        '<div class="dy-search">' +
          '<div class="dy-search__row">' +
            '<input id="dy-commune" type="text" role="combobox" aria-expanded="false" aria-autocomplete="list" ' +
              'aria-controls="dy-ac" autocomplete="off" placeholder="Votre commune ou code postal…">' +
            '<button class="dy-btn" data-dy="go">Analyser mon eau</button>' +
          '</div>' +
          '<div id="dy-ac" class="dy-ac" role="listbox" hidden></div>' +
        '</div>' +
        '<div id="dy-etape2" class="dy-step" hidden></div>' +
        '<div class="dy-hero__proofs" aria-label="À propos de l’analyse">' +
          '<div><strong>Données publiques</strong><span>Hub\u2019Eau · contrôles sanitaires</span></div>' +
          '<div><strong>Analyse par réseau</strong><span>Pour éviter une moyenne trop générale</span></div>' +
          '<div><strong>Sans inscription</strong><span>Le résultat s\u2019affiche immédiatement</span></div>' +
        '</div>' +
        (cfg.demo ? '<p class="dy-hero__hint">Mode démo — essayez <button data-dy="demo-grenoble">Grenoble</button>.</p>' : '') +
      '</section>' +
      '<section id="dy-presearch" class="dy-presearch" aria-label="Ce que contient votre analyse">' +
        '<div class="dy-presearch__head">' +
          '<p class="dy-eyebrow">Ce que vous allez découvrir</p>' +
          '<h2>Un rapport local, lisible et utile — pas une liste de chiffres.</h2>' +
          '<p>Dyese reprend les mesures publiques disponibles pour votre réseau et les remet en contexte : ce qui est conforme, ce qui mérite attention et ce qu\u2019un système de filtration peut réellement traiter.</p>' +
        '</div>' +
        '<div class="dy-presearch__grid">' +
          '<article class="dy-presearch__card"><span>01</span><h3>Microbiologie</h3><p>Coliformes, E. coli, entérocoques et autres indicateurs bactériologiques suivis sur votre réseau.</p></article>' +
          '<article class="dy-presearch__card"><span>02</span><h3>Goût & sous-produits</h3><p>Chlore, THM, carbone organique et paramètres qui peuvent influencer le goût ou le confort.</p></article>' +
          '<article class="dy-presearch__card"><span>03</span><h3>Micropolluants & PFAS</h3><p>Pesticides, nitrates, métaux, PFAS et autres composés dissous quand ils sont recherchés.</p></article>' +
        '</div>' +
        '<p class="dy-presearch__note"><strong>À savoir :</strong> la qualité peut différer entre plusieurs réseaux d\u2019une même commune. C\u2019est pourquoi l\u2019outil vous demande votre unité de distribution avant d\u2019afficher le rapport.</p>' +
      '</section>' +
      '<div id="dy-results" class="dy-results" hidden aria-live="polite"></div>';
  }

  /* Bloc accueil : acquisition courte, puis redirection vers le rapport complet. */
  function accueilHTML(cfg) {
    return '' +
      '<section class="dy-accueil">' +
        (cfg.logoUrlDark ? '<img class="dy-accueil__logo" src="' + cfg.logoUrlDark + '" alt="' + cfg.brandName + '">' : '') +
        '<p class="dy-eyebrow" style="margin-top:0">Analyse gratuite · données officielles</p>' +
        '<h2 class="dy-accueil__t">Que contient vraiment l\u2019eau de votre commune ?</h2>' +
        '<p class="dy-accueil__s">Indiquez votre commune puis votre réseau. Vous arrivez directement sur votre rapport des 12 derniers mois, sans refaire la recherche.</p>' +
        '<div class="dy-search dy-search--light">' +
          '<p class="dy-step__k">Étape 1 sur 2</p>' +
          '<div class="dy-search__row">' +
            '<input id="dy-commune" type="text" role="combobox" aria-expanded="false" aria-autocomplete="list" ' +
              'aria-controls="dy-ac" autocomplete="off" placeholder="Votre commune ou code postal…">' +
            '<button class="dy-btn" data-dy="go">Continuer</button>' +
          '</div>' +
          '<div id="dy-ac" class="dy-ac" role="listbox" hidden></div>' +
        '</div>' +
        '<div id="dy-etape2" class="dy-step" hidden></div>' +
        '<div class="dy-accueil__proofs"><span>Données Hub\u2019Eau</span><span>Analyse par réseau</span><span>Résultat immédiat</span></div>' +
      '</section>';
  }

  function mountAutocomplete(root) {
    var input = root.querySelector('#dy-commune');
    var ac = root.querySelector('#dy-ac');
    var results = [], active = -1;

    function close() { ac.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function open() { if (ac.children.length) { ac.hidden = false; input.setAttribute('aria-expanded', 'true'); } }
    function draw() {
      ac.innerHTML = results.map(function (c, i) {
        return '<div class="dy-ac__item" role="option" id="dy-ac-' + i + '" aria-selected="' + (i === active) + '" data-code="' + c.code + '">' +
          '<span>' + R._esc(c.nom) + '</span><small>' + R._esc(c.dep || c.code) + '</small></div>';
      }).join('');
      Array.prototype.forEach.call(ac.querySelectorAll('.dy-ac__item'), function (item) {
        item.addEventListener('mousedown', function (e) { e.preventDefault(); choose(item.getAttribute('data-code'), item.querySelector('span').textContent); });
      });
      open();
    }
    var run = debounce(function () {
      searchCommunes(input.value).then(function (list) { results = list.slice(0, 8); active = -1; if (results.length) draw(); else close(); });
    }, 220);

    input.addEventListener('input', run);
    input.addEventListener('keydown', function (e) {
      if (ac.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, results.length - 1); highlight(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); highlight(); }
      else if (e.key === 'Enter') { if (active >= 0) { e.preventDefault(); var c = results[active]; choose(c.code, c.nom); } }
      else if (e.key === 'Escape') { close(); }
    });
    function highlight() {
      Array.prototype.forEach.call(ac.children, function (n, i) { n.setAttribute('aria-selected', i === active); if (i === active) input.setAttribute('aria-activedescendant', 'dy-ac-' + i); });
    }
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });

    function choose(code, nom) { input.value = nom; close(); onChoose(root, code, nom); }
    root.querySelector('[data-dy="go"]').addEventListener('click', function () {
      if (results[0]) choose(results[0].code, results[0].nom);
    });
    var demoBtn = root.querySelector('[data-dy="demo-grenoble"]');
    if (demoBtn) demoBtn.addEventListener('click', function () { input.value = 'Grenoble'; launch(root, '38185', 'Grenoble'); });
  }

  /* ------------------- aiguillage apres choix de commune ---------------- */
  // Mode 'page'    : etape 2 (reseau) puis analyse sur place.
  // Mode 'accueil' : etape 2 (reseau) puis REDIRECTION vers la page d'analyse.
  function onChoose(root, code, nom) {
    var zone = root.querySelector('#dy-etape2');
    if (!zone) return launch(root, code, nom);
    zone.hidden = false;
    zone.innerHTML = '<p class="dy-step__load">Recherche des réseaux de distribution…</p>';
    fetchReseaux(code).then(function (d) {
      var rs = (d && d.reseaux) || [];
      var opts = rs.map(function (r, i) {
        return '<button type="button" class="dy-step__opt" data-udi="' + esc(r.code) + '">' +
          '<span class="dy-step__optn">' + esc(r.nom) + '</span>' +
          '<span class="dy-step__opth">Réseau ' + esc(r.code) + '</span></button>';
      }).join('');
      zone.innerHTML =
        '<p class="dy-step__k">Étape 2 sur 2</p>' +
        '<h3 class="dy-step__t">Quel réseau vous dessert à ' + esc(nom) + ' ?</h3>' +
        '<p class="dy-step__s">' + (rs.length > 1
          ? 'Votre commune compte ' + rs.length + ' réseaux de distribution. Choisissez le vôtre, ou analysez-les tous.'
          : 'Une seule unité de distribution dessert votre commune.') + '</p>' +
        '<div class="dy-step__opts">' + opts +
          '<button type="button" class="dy-step__opt dy-step__opt--all" data-udi="">' +
            '<span class="dy-step__optn">Toute la commune</span>' +
            '<span class="dy-step__opth">Tous les réseaux agrégés</span></button>' +
        '</div>';
      zone.querySelectorAll('.dy-step__opt').forEach(function (b) {
        b.addEventListener('click', function () {
          var udi = b.getAttribute('data-udi') || '';
          if (state.cfg.mode === 'accueil') {
            saveSelection(code, nom, udi);
            var u = analyseUrl(code, nom, udi);
            track('etape2_valide', { commune: code, reseau: udi || 'tous' });
            window.location.assign(u);
          } else {
            zone.hidden = true;
            launch(root, code, nom, udi);
          }
        });
      });
    });
  }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* --------------------------- lancer l'analyse ------------------------- */
  function launch(root, code, nom, udi) {
    var results = root.querySelector('#dy-results');
    var presearch = root.querySelector('#dy-presearch');
    if (presearch) presearch.hidden = true;
    root.classList.add('dyese-root--has-analysis');
    results.hidden = false;
    results.innerHTML = '<div class="dy-skeleton" role="status" aria-label="Analyse en cours"></div>';
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('analyse_lancee', { commune: code, reseau: udi || 'tous' });

    fetchAnalyse(code, udi).then(function (analysis) {
      state.current = analysis;
      // Moteur de rendu pluggable : vue détaillée (DyeseRender) ou épurée
      // (DyeseLanding), selon config.renderer.
      (state.cfg.renderer || R).renderInto(results, analysis, state.cfg);
      wireResults(root, results);
    }).catch(function (err) {
      results.innerHTML = '<div class="dy-summary"><h2>Analyse indisponible</h2>' +
        '<p>' + (state.cfg.demo
          ? 'La démo autonome contient seulement Grenoble (38185). Déployez le Cloudflare Worker pour couvrir toutes les communes.'
          : 'Impossible de récupérer les données pour cette commune pour le moment. Réessayez dans un instant.') +
        '</p></div>';
    });
  }

  /* -------------------- interactions post-rendu ------------------------- */
  function wireResults(root, results) {
    // clic produit → GA4
    results.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-dy-product]');
      if (a) track('clic_produit', { produit: a.getAttribute('data-dy-product'), commune: state.current && state.current.commune && state.current.commune.code });
    });
    // formulaire lead
    var form = results.querySelector('.dy-lead__form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitLead(form); });
  }

  /* ------------------------------- lead --------------------------------- */
  function submitLead(form) {
    var err = form.querySelector('.dy-lead__err');
    var prenom = form.prenom.value.trim();
    var email = form.email.value.trim();
    var tel = form.tel.value.trim();
    var consent = form.consent.checked;
    err.hidden = true;

    if (!prenom) return showErr(err, 'Merci d’indiquer votre prénom.');
    if (!email && !tel) return showErr(err, 'Indiquez un e-mail ou un téléphone.');
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return showErr(err, 'E-mail invalide.');
    if (!consent) return showErr(err, 'Le consentement est nécessaire pour vous envoyer le rapport.');

    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = 'Génération du rapport…';

    // 1) PDF côté navigateur (téléchargement immédiat)
    buildPDF(state.current).then(function () {
      // 2) Envoi du lead au Worker (POST — pas de PII en URL)
      var payload = {
        prenom: prenom, email: email, tel: tel, consent: true,
        commune: state.current && state.current.commune,
        verdict: state.current && state.current.verdict && state.current.verdict.titre,
        reco: state.current && state.current.besoins && state.current.besoins.primaire,
        source: 'dyese-analyse-v2', ts: new Date().toISOString(),
      };
      var endpoint = state.cfg.espEndpoint || api('/api/lead');
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .catch(function () { /* le PDF est déjà fourni : on n'échoue pas l'UX */ });
    }).then(function () {
      track('lead_soumis', { commune: state.current && state.current.commune && state.current.commune.code });
      form.outerHTML = '<p class="dy-lead__ok">Merci ' + R._esc(prenom) + ' ! Votre rapport PDF a été téléchargé' + (email ? ' et une copie vous est envoyée par e-mail' : '') + '.</p>';
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Recevoir mon rapport PDF';
      showErr(err, 'Un souci est survenu. Réessayez.');
    });
  }
  function showErr(err, msg) { err.textContent = msg; err.hidden = false; }

  /* ---------------------------- PDF (jsPDF) ----------------------------- */
  function loadJsPDF() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  function buildPDF(a) {
    return loadJsPDF().then(function () {
      var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'a4' });
      var W = 595, M = 48, y = 64;
      var navy = [27, 37, 64], ink = [22, 32, 43], muted = [107, 120, 133];
      function line(txt, size, color, gap, bold) {
        doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(size); doc.setTextColor(color[0], color[1], color[2]);
        var lines = doc.splitTextToSize(txt, W - M * 2);
        doc.text(lines, M, y); y += lines.length * (size + 4) + (gap || 0);
      }
      doc.setFillColor(navy[0], navy[1], navy[2]); doc.rect(0, 0, W, 40, 'F');
      doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(14);
      doc.text((state.cfg.brandName || 'Dyese') + ' — Analyse de l’eau', M, 26);
      var c = a.commune || {};
      line((c.nom || '') + ' (' + (c.code || '') + ')', 18, ink, 6, true);
      line((a.verdict && a.verdict.titre) || '', 12, ink, 4, true);
      line((a.verdict && a.verdict.texte) || '', 10, muted, 10);
      line(a.nbPrelevements + ' prélèvements · ' + a.nbParametres + ' paramètres · ' + a.nbSubstancesDetectees + ' substances détectées · ' + (a.conformite === 'conforme' ? 'Conforme' : a.conformite), 10, ink, 12);
      (a.indicateurs || []).forEach(function (ind) {
        var st = ind.statutBloc === 'rouge' ? 'Dépassement' : ind.statutBloc === 'ambre' ? 'À surveiller' : ind.statutBloc === 'info' ? 'Informatif' : 'RAS';
        line(ind.titre + '  —  ' + st, 12, navy, 2, true);
        var dets = (ind.substances || []).filter(function (s) { return s.detecte; }).slice(0, 6)
          .map(function (s) { return '• ' + s.nom + ' : ' + (R._nf(s.valeurMax)) + ' ' + s.unite + (s.seuil ? ' (seuil ' + R._nf(s.seuil.valeur) + ' ' + (s.seuil.unite || s.unite) + ')' : ''); });
        if (!dets.length) dets = ['• Aucune substance détectée.'];
        line(dets.join('\n'), 9.5, muted, 8);
        if (y > 720) { doc.addPage(); y = 64; }
      });
      if (a.pfas) line('Somme 20 PFAS : ' + R._nf(a.pfas.sommeUgL) + ' µg/L (seuil ' + a.pfas.seuilUgL + ' µg/L, Directive UE 2020/2184). Composés dissous non retenus par la microfiltration 0,2 µm.', 9.5, muted, 12);
      if (y > 700) { doc.addPage(); y = 64; }
      line('Recommandation : ' + ((a.besoins && a.besoins.primaire) || '') + '. ' + ((a.besoins && a.besoins.messageChimiqueDissous) || ''), 10, ink, 12, true);
      line('Sources : Hub’Eau · Directive UE 2020/2184 · ANSES. Analyse indicative, ne remplace pas un avis sanitaire officiel. ' +
        'Dyese ne revendique aucune élimination de substances non traitées par ses filtres.', 8, muted, 0);
      doc.save('dyese-analyse-' + (c.code || 'eau') + '.pdf');
    });
  }

  /* ------------------------------- init --------------------------------- */
  function init(rootEl, userConfig) {
    var cfg = Object.assign({}, DEFAULTS, userConfig || {});
    cfg.products = Object.assign({}, DEFAULTS.products, (userConfig && userConfig.products) || {});
    state.cfg = cfg;
    if (!rootEl.classList.contains('dyese-root')) rootEl.classList.add('dyese-root');
    rootEl.innerHTML = heroHTML(cfg);
    mountAutocomplete(rootEl);
    mountCMP();

    // Arrivée depuis le bloc accueil (ou un lien partagé).
    // 1) paramètres URL ; 2) secours sessionStorage si Shopify/le thème a perdu
    //    la query string pendant la navigation.
    if (cfg.mode !== 'accueil' && cfg.autoFromUrl) {
      var selection = readUrlSelection() || readStoredSelection();
      if (selection && validInsee(selection.insee)) {
        var champ = rootEl.querySelector('#dy-commune');
        if (champ) champ.value = selection.commune || selection.insee;

        /* Si le secours session a été utilisé, on remet une URL partageable
           sans recharger la page. */
        if (selection.source === 'session' && window.history && window.history.replaceState) {
          try {
            var canonical = analyseUrl(selection.insee, selection.commune, selection.udi);
            window.history.replaceState(null, '', canonical);
          } catch (e) {}
        }

        clearStoredSelection();
        launch(rootEl, selection.insee, selection.commune || selection.insee, selection.udi || '');
      }
    }
    return { launch: function (code, nom, udi) { launch(rootEl, code, nom, udi); } };
  }

  root.DyeseWidget = { init: init, _track: track };
})(typeof self !== 'undefined' ? self : this);
